module.exports = __webpack_public_path__ + "img/authen_zhangqi.b5970b1e.png";